const tvActions = {
  REQUEST_WEATHER_FOR_TV: 'REQUEST_WEATHER_FOR_TV',
  REQUEST_WEATHER_FOR_TV_WAITING: 'REQUEST_WEATHER_FOR_TV_WAITING',
  REQUEST_WEATHER_FOR_TV_SUCCESS: 'REQUEST_WEATHER_FOR_TV_SUCCESS',
  REQUEST_WEATHER_FOR_TV_ERROR: 'REQUEST_WEATHER_FOR_TV_ERROR',
  CREATE_TV_LISTENER: 'CREATE_TV_LISTENER',
  UPDATE_PATIENTS_LIST: 'UPDATE_PATIENTS_LIST',
  CALL_PATIENT_TV: 'CALL_PATIENT_TV',
  CALL_PATIENT_TV_ERROR: 'CALL_PATIENT_TV_ERROR',
  CALL_PATIENT_TV_SUCCESS: 'CALL_PATIENT_TV_SUCCESS',
  START_TV: 'START_TV',
  START_TV_ERROR: 'START_TV_ERROR',
  START_TV_SUCCESS: 'START_TV_SUCCESS',
  VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL: 'VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL',
  VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_WAITING: 'VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_WAITING',
  VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID: 'VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID',
  VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_ERROR: 'VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_ERROR',
  GET_STORED_CODE_FOR_TV_CACHED_ON_PROFESSIONAL_PC: 'GET_STORED_CODE_FOR_TV_CACHED_ON_PROFESSIONAL_PC',
  RESET_TV_CODE_ON_CACHE: 'RESET_TV_CODE_ON_CACHE',
  RESET_TV_CODE_ON_CACHE_FINISHED: 'RESET_TV_CODE_ON_CACHE_FINISHED',
  GET_CACHED_VALUES_FOR_TV: 'GET_CACHED_VALUES_FOR_TV',
  GET_CACHED_VALUES_FOR_TV_FINISHED: 'GET_CACHED_VALUES_FOR_TV_FINISHED',
  SAVE_TV_INFO_ON_CACHE: 'SAVE_TV_INFO_ON_CACHE',
  SAVE_TV_INFO_ON_CACHE_SUCCESS: 'SAVE_TV_INFO_ON_CACHE_SUCCESS',
  SAVE_TV_INFO_ON_CACHE_ERROR: 'SAVE_TV_INFO_ON_CACHE_SUCCESS',
  GET_TV_PERMISSION_SUCCESS: 'GET_TV_PERMISSION_SUCCESS',
  callPatient: (tvId, patient, tvProfessional, tvClinic, tvRoom) => ({
    type: tvActions.CALL_PATIENT_TV,
    payload: {
      tvId,
      patient,
      tvProfessional,
      tvClinic,
      tvRoom,
    },
  }),
  startTv: () => ({
    type: tvActions.START_TV,
  }),
  validateCodeProvidedByProfessional: (code, isStartingTv = false) => ({
    type: tvActions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL,
    payload: {
      code,
      isStartingTv,
    },
  }),
  getProfessionaTvCode: () => ({
    type: tvActions.GET_STORED_CODE_FOR_TV_CACHED_ON_PROFESSIONAL_PC,
  }),
  resetTvCodeOnCache: () => ({
    type: tvActions.RESET_TV_CODE_ON_CACHE,
  }),
  getCachedValuesForTv: () => ({
    type: tvActions.GET_CACHED_VALUES_FOR_TV,
  }),
  saveTvInfoOnCache: (tvProfessional, tvClinic, tvRoom) => ({
    type: tvActions.SAVE_TV_INFO_ON_CACHE,
    payload: {
      tvProfessional,
      tvClinic,
      tvRoom,
      shouldReload: true,
    },
  }),
  requestWeatherForTv: () => ({
    type: tvActions.REQUEST_WEATHER_FOR_TV,
  }),
};
export default tvActions;
